import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  container: { padding: theme.spacing(2), gap: theme.spacing(2) },
  title: {
    fontWeight: 500,
    padding: theme.spacing(2),
    color: theme.palette.primary.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.accent.main,
    paddingBottom: theme.spacing(2)
  },
  actionButtons: { padding: theme.spacing(2) }
}));
